import { Controller, useFormContext } from "react-hook-form";
import { FormGroup, Input, Label } from "reactstrap";

export const FormSwitch = ({
  name,
  disabled = false,
  className = "",
  label = "",
  ...rest
}) => {
  // ** Hooks
  const { control } = useFormContext();

  return (
    <FormGroup
      noMargin
      className={`mb-1 d-flex align-items-center ${className}`}
      switch
    >
      <Controller
        name={name}
        control={control}
        defaultValue={false}
        render={({ field: { onChange, value, ref } }) => (
          <Input
            innerRef={ref}
            type="switch"
            role="switch"
            id={name}
            onChange={onChange}
            checked={value}
            className="me-50"
            disabled={disabled}
            {...rest}
          />
        )}
      />
      {label && (
        <Label for={name} className="mb-0">
          {label}
        </Label>
      )}
    </FormGroup>
  );
};
